import React, { useState, useEffect } from 'react';
import { ReactComponent as SvgWeightLoss } from "../../assets/lessWeight.svg";
import { ReactComponent as SvgMuscleGain } from "../../assets/muscul.svg";
import { ReactComponent as SvgBodyRecomp } from "../../assets/BodyRecomp.svg";
import { ReactComponent as SvgUndecided } from "../../assets/idk.svg";

// Импортируем изображения напрямую
// Используем относительные пути для импорта изображений
import muscleGainImg from "../../assets/fitness/fit2.png";
import weightLossImg from "../../assets/fitness/fit1.png";
import bodyRecompImg from "../../assets/fitness/fit3.png";
import undecidedImg from "../../assets/fitness/fit4.png";

const FitnessGoalPage = ({ userData, updateUserData, onNext, currentStep, totalSteps }) => {
    const [selectedGoal, setSelectedGoal] = useState(userData.goal2 || "");
    const [imagesLoaded, setImagesLoaded] = useState(false);

    const fitnessGoals = [
        {
            id: "Набор мышечной массы",
            icon: <SvgMuscleGain />,
            title: "Набор мышечной массы",
            image: muscleGainImg
        },
        {
            id: "Сбросить лишние килограммы",
            icon: <SvgWeightLoss />,
            title: "Сбросить лишние килограммы",
            image: weightLossImg
        },
        {
            id: "Рекомпозиция тела",
            icon: <SvgBodyRecomp />,
            title: "Рекомпозиция тела",
            image: bodyRecompImg
        },
        {
            id: "Не определился(лась) с ответом",
            icon: <SvgUndecided />,
            title: "Не определился(лась) с ответом",
            image: undecidedImg
        }
    ];

    // Имитация загрузки изображений
    useEffect(() => {
        const timer = setTimeout(() => {
            setImagesLoaded(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const handleGoalSelect = (goalId) => {
        // Если цель уже выбрана, снимаем выбор
        if (selectedGoal === goalId) {
            setSelectedGoal("");
            updateUserData('goal2', "");
        } else {
            // Иначе выбираем новую цель
            setSelectedGoal(goalId);
            updateUserData('goal2', goalId);
        }
    };

    const handleSkip = () => {
        onNext();
    };

    return (
        <div className="onboarding-page">
            <div className="onboarding-header">
                <h2>Укажите вашу фитнес-цель</h2>
            </div>

            <div className="onboarding-content">
                <div className="fitness-goals-grid">
                    {fitnessGoals.map((goal) => (
                        <div
                            key={goal.id}
                            className={`fitness-goal-card ${selectedGoal && selectedGoal !== goal.id ? 'inactive' : ''} ${selectedGoal === goal.id ? 'selected' : ''}`}
                            onClick={() => handleGoalSelect(goal.id)}
                        >
                            <div className="fitness-goal-image-container">
                                {!imagesLoaded ? (
                                    <div className="fitness-goal-image-placeholder">
                                        {goal.icon}
                                    </div>
                                ) : (
                                    <div
                                        className="fitness-goal-image"
                                        style={{ backgroundImage: `url(${goal.image})` }}
                                    >
                                        {/* Фоновое изображение */}
                                    </div>
                                )}
                            </div>
                            <div className="fitness-goal-title">{goal.title}</div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="onboarding-footer">
                <div className="progress-dots">
                    {Array.from({ length: totalSteps }, (_, i) => (
                        <div
                            key={i}
                            className={`progress-dot ${i + 1 === currentStep ? 'active' : ''}`}
                        />
                    ))}
                </div>
                <button className="skip-button" onClick={handleSkip}>
                    Заполнить позже
                </button>
                <button
                    className="next-button"
                    onClick={onNext}
                >
                    Далее
                </button>
            </div>
        </div>
    );
};

export default FitnessGoalPage; 